__webpack_require__.p = "https://live2.stagecliengo.com/";